import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_2/BuildingInstructions_Images/MainModels`

const Pic1 = `${FullPath}/Ballerina/1_1x.png`;
const Pic2 = `${FullPath}/Ballerina/2_1x.png`;
const Pic3 = `${FullPath}/Ballerina/3_1x.png`;
const Pic4 = `${FullPath}/Ballerina/4_1x.png`;
const Pic5 = `${FullPath}/Ballerina/5_1x.png`;
const Pic6 = `${FullPath}/Ballerina/6_1x.png`;
const Pic7 = `${FullPath}/Ballerina/7_1x.png`;
const Pic8 = `${FullPath}/Ballerina/8_1x.png`;
const Pic9 = `${FullPath}/Ballerina/9_1x.png`;
const Pic10 = `${FullPath}/Ballerina/10_1x.png`;
const Pic11 = `${FullPath}/Ballerina/11_1x.png`;
const Pic12 = `${FullPath}/Ballerina/12_1x.png`;
const Pic13 = `${FullPath}/Ballerina/13_1x.png`;
const Pic14 = `${FullPath}/Ballerina/14_1x.png`;
const Pic15 = `${FullPath}/Ballerina/15_1x.png`;
const Pic16 = `${FullPath}/Ballerina/16_1x.png`;
const Pic17 = `${FullPath}/Ballerina/17_1x.png`;
const Pic18 = `${FullPath}/Ballerina/18_1x.png`;
const Pic19 = `${FullPath}/Ballerina/19_1x.png`;
const Pic20 = `${FullPath}/Ballerina/20_1x.png`;
const Pic21 = `${FullPath}/Ballerina/21_1x.png`;
const Pic22 = `${FullPath}/Ballerina/22_1x.png`;
const Pic23 = `${FullPath}/Ballerina/23_1x.png`;
const Pic24 = `${FullPath}/Ballerina/24_1x.png`;
const Pic25 = `${FullPath}/Ballerina/25_1x.png`;
const Pic26 = `${FullPath}/Ballerina/26_1x.png`;
const Pic27 = `${FullPath}/Ballerina/27_1x.png`;
const Pic28 = `${FullPath}/Ballerina/28_1x.png`;
const Pic29 = `${FullPath}/Ballerina/29_1x.png`;
const Pic30 = `${FullPath}/Ballerina/30_1x.png`;
const Pic31 = `${FullPath}/Ballerina/31_1x.png`;
const Pic32 = `${FullPath}/Ballerina/32_1x.png`;
const Pic33 = `${FullPath}/Ballerina/33_1x.png`;
const Pic34 = `${FullPath}/Ballerina/34_1x.png`;
const Pic35 = `${FullPath}/Ballerina/35_1x.png`;
const Pic36 = `${FullPath}/Ballerina/36_1x.png`;
const Pic37 = `${FullPath}/Ballerina/37_1x.png`;
const Pic38 = `${FullPath}/Ballerina/38_1x.png`;
const Pic39 = `${FullPath}/Ballerina/39_1x.png`;
const Pic40 = `${FullPath}/Ballerina/40_1x.png`;
const Pic41 = `${FullPath}/Ballerina/41_1x.png`;
const Pic42 = `${FullPath}/Ballerina/42_1x.png`;
const Pic43 = `${FullPath}/Ballerina/43_1x.png`;
const Pic44 = `${FullPath}/Ballerina/44_1x.png`;
const Pic45 = `${FullPath}/Ballerina/45_1x.png`;
const Pic46 = `${FullPath}/Ballerina/46_1x.png`;
const Pic47 = `${FullPath}/Ballerina/47_1x.png`;
const Pic48 = `${FullPath}/Ballerina/48_1x.png`;
const Pic49 = `${FullPath}/Ballerina/49_1x.png`;


export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
        Pic12,
        Pic13,
        Pic14,
        Pic15,
        Pic16,
        Pic17,
        Pic18,
        Pic19,
        Pic20,
        Pic21,
        Pic22,
        Pic23,
        Pic24,
        Pic25,
        Pic26,
        Pic27,
        Pic28,
        Pic29,
        Pic30,
        Pic31,
        Pic32,
        Pic33,
        Pic34,
        Pic35,
        Pic36,
        Pic37,
        Pic38,
        Pic39,
        Pic40,
        Pic41,
        Pic42,
        Pic43,
        Pic44,
        Pic45,
        Pic46,
        Pic47,
        Pic48,
        Pic49,
    
    

    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}